
import { Card, CardContent } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from "recharts";
import { CHART_COLORS } from "../constants/chartColors";
import type { Candidate } from "@/components/candidates/types";

export interface ConversionRateChartProps {
  candidates: Candidate[];
  data: Array<{ name: string; rate: number }>;
}

// Define proper types for Recharts components
interface TooltipPayload {
  value: number;
  name: string;
  dataKey: string;
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipPayload[];
  label?: string;
}

interface LabelProps {
  value: number;
}

export const ConversionRateChart = ({ data }: ConversionRateChartProps) => {
  const customTooltipFormatter = (value: number, name: string): [string, string] => {
    const numValue = typeof value === 'number' ? value.toFixed(1) : value;
    return [`${numValue}%`, 'Conversion Rate'];
  };

  const customLabelFormatter = (label: string) => `Source: ${label}`;

  const labelFormatter = (value: number): string => {
    const numValue = typeof value === 'number' ? value.toFixed(1) : value;
    return `${numValue}%`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 5, right: 50, left: 20, bottom: 5 }}
        layout="vertical"
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
        <XAxis 
          type="number" 
          domain={[0, 100]} 
          tickFormatter={(value: number) => `${value}%`} 
        />
        <YAxis 
          type="category" 
          dataKey="name" 
          width={100}
          tick={{ fontSize: 12 }}
        />
        <Tooltip 
          formatter={customTooltipFormatter}
          labelFormatter={customLabelFormatter}
        />
        <Bar 
          dataKey="rate" 
          fill={CHART_COLORS.primary[4]} 
          radius={[0, 4, 4, 0]}
        >
          <LabelList 
            dataKey="rate" 
            position="right" 
            formatter={labelFormatter}
            style={{ fill: "#374151", fontWeight: 500, fontSize: 12 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
